<template>
  <q-page class="flex-center">
    <div class="q-pa-md">
      <q-table
        title="Régua de relacionamento"
        :data="entities"
        :columns="columns"
        :visible-columns="visibleColumns"
        row-key="id"
        :loading="isLoading"
        :pagination.sync="pagination"
      >

      <template v-slot:body-cell-options="value">
        <q-td>
          <q-btn round color="primary" @click="upsertEntity(value, true)" icon="edit"/>
        </q-td>

        <q-td>
          <q-btn round color="primary" @click="deleteEntity(value)" icon="delete"/>
        </q-td>
      </template>

      <!-- https://quasar.dev/vue-components/table#example--custom-top-with-add-remove-row -->
      <template v-slot:top>
        <q-btn color="primary" label="Adiciona" @click="upsertEntity(undefined, false)" />
        <!--
        <q-btn class="q-ml-sm" color="primary" :disable="loading" label="Remove row" @click="removeRow" />
        <q-space />
        <q-input borderless dense debounce="300" color="primary" v-model="filter">
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
        -->
      </template>

      </q-table>
    </div>

    <q-dialog v-model="modal.isActive">
      <q-card style="width: 80vw; max-width: 80vw;">
        <RelationshipRuleForm
          :id="current.id"
          :area="current.area"
          :area_label="current.area_label"
          :actions="current.actions"
          :internal_description="current.internal_description"
          :public_description="current.public_description"
          :type="current.type"
          :type_label="current.type_label"
          :editing="modal.isEditing"

          :onClose="(updatedValue) => {
            updateCurrent(updatedValue);
            toggleModal(false);
          }"
        />

        <q-inner-loading :showing="modal.isLoading">
          <q-spinner-dots size="50px" color="primary"/>
        </q-inner-loading>

        <br>
        <br>

      </q-card>
    </q-dialog>

  </q-page>
</template>

<script>
import { setupAxios } from './microfrontend/setupAxios';
import { getRelationshipRules, deleteRelationshipRule } from './microfrontend/apiClient';
import RelationshipRuleForm from '../views/microfrontend/DonationsManager/RelationshipRuleForm/RelationshipRuleForm';

export default {
  name: 'RelationshipRule',
  components: { RelationshipRuleForm },
  data () {
    return {
      entities: [],
      columns: [
        {
          name: 'id',
          label: 'ID da role',
          align: 'left',
          field: 'id'
        },
        {
          name: 'area',
          label: 'area',
          align: 'left',
          field: 'area'
        },
        {
          name: 'area_label',
          label: 'ÁREA',
          align: 'left',
          field: 'area_label'
        },
        {
          name: 'actions',
          label: 'AÇÔES',
          align: 'left',
          field: 'actions',
          required: true
        },
        {
          name: 'internal_description',
          label: 'DESCRIÇÃO INTERNA',
          align: 'left',
          field: 'internal_description',
          required: true
        },
        {
          name: 'type',
          label: 'type',
          align: 'left',
          field: 'type'
        },
        {
          name: 'type_label',
          label: 'COMUNICAÇÃO',
          align: 'left',
          field: 'type_label'
        },
        {
          name: 'public_description',
          label: 'DESCRIÇÃO PÚBLICA',
          align: 'left',
          field: 'public_description',
          required: false
        },
        {
          name: 'options',
          label: 'Editar',
          align: 'left',
          field: 'options',
          required: true
        },
        {
          name: 'delete',
          label: 'Deletar',
          align: 'left',
          field: 'delete',
          required: true
        }
      ],
      visibleColumns: [
        'area_label',
        'actions',
        'internal_description',
        'type_label',
        'public_description'
      ],
      pagination: {
        page: 1,
        rowsPerPage: 0
      },
      isLoading: false,
      modal: {
        isActive: false,
        isLoading: false,
        isEditing: false
      },
      current: {
        id: '',
        area: '',
        area_label: '',
        actions: '',
        internal_description: '',
        public_description: '',
        type: '',
        type_label: ''
      }
    };
  },
  async mounted () {
    this.axios = setupAxios();
    await this.getRelationshipRules();
  },
  methods: {
    async getRelationshipRules () {
      this.entities = (await getRelationshipRules(this.axios)).data;
    },
    updateCurrent (value) {
      if (this.modal.isEditing) {
        this.handleUpdateCurrent(value);
      } else {
        this.handleNewCurrent(value);
      };
    },
    handleNewCurrent (newValue) {
      this.entities.push(newValue);
    },
    handleUpdateCurrent (updatedValue) {
      this.current.area = updatedValue.area;
      this.current.area_label = updatedValue.area_label;
      this.current.actions = updatedValue.actions;
      this.current.internal_description = updatedValue.internal_description;
      this.current.public_description = updatedValue.public_description;
      this.current.type = updatedValue.type;
      this.current.type_label = updatedValue.type_label;

      this.entities = this.entities.map(e => {
        if (e.id === updatedValue.id) {
          return this.current;
        }
        return e;
      });
    },
    handleDeleteCurrent (deletedValue) {
      this.entities = this.entities.filter(d => {
        return d.id !== deletedValue.id;
      });
    },
    upsertEntity (value, isEditing) {
      this.modal.isEditing = isEditing;
      this.toggleModal(true);
      this.current.id = isEditing ? value.row.id : undefined;
      this.current.area = isEditing ? value.row.area : undefined;
      this.current.area_label = isEditing ? value.row.area_label : undefined;
      this.current.actions = isEditing ? value.row.actions : undefined;
      this.current.internal_description = isEditing ? value.row.internal_description : undefined;
      this.current.public_description = isEditing ? value.row.public_description : undefined;
      this.current.type = isEditing ? value.row.type : undefined;
      this.current.type_label = isEditing ? value.row.type_label : undefined;
    },
    async deleteEntity (value) {
      this.isLoading = true;
      const res = await deleteRelationshipRule(this.axios, value.row.id);
      if (res && res.status === 200) {
        alert('Regra de relacionamento deletado!');
        this.handleDeleteCurrent(res.data.entity);
      }
      this.isLoading = false;
    },
    toggleModal (toggle) {
      this.modal.isActive = toggle;
    },
    addEntity () {

    }
  }
};
</script>
